<template>
  <app-widget 
    :title="$t('device.moveDetails')"
    :loading="loading">

    <div slot="widget-content">
      <v-list data-cy="moveDetails">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.name') }}: {{ move.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.transferee') }}: {{ `${move.transfereeFirstName} ${move.transfereeLastName}` }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.startDate') }}: {{ move.startDate | date(FULL_DATE_FORMAT) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.endDate') }}: {{ move.plannedDeliveryDate | date(FULL_DATE_FORMAT) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.origin') }}: {{ `${move.origin.street} ${move.origin.number}` }},
              {{move.origin.city}}{{move.origin.state ? ', ' : null}}{{move.origin.state}}{{move.origin.country ? ', ' : null}}{{move.origin.country}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.destination') }}: {{ `${move.destination.street} ${move.destination.number}` }},
              {{move.destination.city}}{{move.destination.state ? ', ' : null}}{{move.destination.state}}{{move.destination.country ? ', ' : null}}{{move.destination.country}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.status') }}: {{ $t(`move.type.${MOVE_STATUS_TYPE_ARR[move.moveStatus]}`) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('move.properties.tracker') }}: {{ move.device.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </app-widget>
</template>

<script>
import AppWidget from '@/components/widgets/AppWidget';
import { FULL_DATE_FORMAT } from '@/constants/date';
import { MOVE_STATUS_TYPE_ARR } from '@/constants';


export default {
  name: 'DeviceDetailsMove',
  props: {
    move: Object,
    loading: Boolean
  },
  data: () => ({
    FULL_DATE_FORMAT,
    MOVE_STATUS_TYPE_ARR
  }),
  components: {
    AppWidget
  }
}
</script>